var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.221,
    height: 21.918,
    viewBox: "0 0 29.221 21.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1006.384,724.674V708.923c.351-.525.673-.57,1.165-.15q4.559,3.887,9.115,7.777c.961.822,1.9,1.671,2.879,2.47a2.265,2.265,0,0,0,2.127.4,3.729,3.729,0,0,0,1.4-.9q5.717-4.9,11.436-9.8a.65.65,0,0,1,.757-.151.654.654,0,0,1,.342.667c0,5.031,0,10.062-.012,15.093a2.736,2.736,0,0,1-.246,1.127,2.359,2.359,0,0,1-2.3,1.392c-1.817,0-3.633,0-5.45,0q-9.3,0-18.6,0a2.589,2.589,0,0,1-1.787-.619A2.677,2.677,0,0,1-1006.384,724.674Z",
    transform: "translate(1006.384 -704.926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-986.585,658.627q6.021,0,12.041,0a2.462,2.462,0,0,1,1.888.785.654.654,0,0,1-.063,1.094q-3.641,3.1-7.281,6.192c-1.879,1.608-3.742,3.233-5.612,4.851a1.275,1.275,0,0,1-1.986,0q-6.423-5.5-12.85-11c-.467-.4-.49-.741-.06-1.174a2.484,2.484,0,0,1,1.852-.738Q-992.62,658.632-986.585,658.627Z",
    transform: "translate(1001.212 -658.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.31b12d9c.svg";
export { ForwardRef as ReactComponent };